// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","menu2":"Footer_menu2__tm915","link":"Footer_link__Xabb2","icon1":"Footer_icon1__2CL2h","icon2":"Footer_icon2__1--9c","me":"Footer_me__3iHDO"};